<template>
  <div
    class="mx-auto max-w-xl rounded-xl bg-emerald-50 p-4 text-center text-sm text-gray-700"
  >
    <slot />
  </div>
</template>
